import { getInfoSelects, getInfoSelectsGlobal, getListPermisos, getListPermisostenant } from '../request/request'
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks'
import { SetCloud } from '../../../../../redux/feature/CloudSlice'
import { SetTenant } from '../../../../../redux/feature/TenantSlice'
import { SetPlan } from '../../../../../redux/feature/planSlice'
import { SetRegion } from '../../../../../redux/feature/RegionSlice'
import { SetId } from '../../../../../redux/feature/SuscriptionSlice'
import { SetNamesus } from '../../../../../redux/feature/NameSlice'
import { SetNameTenant } from '../../../../../redux/feature/NametenantSlice'
import { getListTenant } from '../../../../../app/modules/custom/accounts/datatransfer/requests/request'
import { useEffect, useState } from 'react'
import { useAuth } from '../../../../../app/modules/auth'
import { useLocation } from 'react-router-dom'
import { MenuItemTenantCTX } from './MenuItemTenant'
import { SetListPerm } from '../../../../../redux/feature/ListPermissionSlice'
import FlagSlice, { setFlagValue } from '../../../../../redux/feature/FlagSlice'

import { MenuCTXWithSub } from './MenuCTX'
import { MenuItemCTX } from './MenuItemCtx'
import { MenuItemCTXaws } from './MenuItemCtx_aws'

import "./estilos.css"

export function MenuInner() {

  type listcloud = {
    name: String
  }

  type listsus = {
    name: String
    id: Number
  }

  type tenats = {
    id: Number,
    Name: string,
    Domain: string
  }

  const Type = useAppSelector(state => state.CloudSlice.Type)
  const nameRegion = useAppSelector(state => state.RegionSlice.name)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const nameSus = useAppSelector(state => state.NameSlice.name)
  const NameTenant = useAppSelector(state => state.NametenantSlice.name)
  const [permissions, setPermissions] = useState([]);
  const { currentUser } = useAuth()

  const dispatch = useAppDispatch()
  const [listRegions, setlistRegions] = useState([""])
  const [listSuscripciones, setlistSuscripciones] = useState<listsus | any>()
  const [listCloud, setlistcloud] = useState<listcloud | any>()

  const [Tenants, setTenants] = useState<tenats[]>([])
  const [stora, setstora] = useState<any>(false)
  const storedTenantId = localStorage.getItem('tenantId');
  const storedTenantName = localStorage.getItem('tenantName');
  const storedCloud = localStorage.getItem('cloud');
  const storedSuscription = localStorage.getItem('suscription');
  const storedSuscriptionName = localStorage.getItem('suscriptionName');
  const storedRegion = localStorage.getItem('region');


  const [Info, setInfo] = useState([{
    id: 0,
    name: '',
    cloud: [
      {
        name: "",
        regions: []
      }
    ],

  }])

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('Tenant.list') || currentUser?.Multitenant) {
      getListTenant().then(response => {
        setTenants(response.data)
        const tenantsData = response.data
        const storedTenant = tenantsData.find((tenant: any) => tenant.id.toString() === storedTenantId);

        if (storedTenant) {
          setstora(true)
          dispatch(SetTenant(Number(storedTenantId)))
          dispatch(SetNameTenant(String(storedTenantName)))
        }
        else if (response.data.length > 0) {
          dispatch(SetTenant(response.data[0].id))
          dispatch(SetNameTenant(response.data[0].Name))
        }
      })
    }
    else {

      if (storedSuscription !== null) {
        setstora(true)

        dispatch(SetId(Number(storedSuscription)))
      }
      else if (storedSuscription === null) {
        dispatch(SetId(Info[0].id))
      }
    }

  }, [tenant])

  useEffect(() => {
    if (!storedTenantName && !storedTenantId && tenant === 0 && stora === false) {
      getInfoSelects().then(response => {
        if (response.data.length !== 0) {
          setInfo(response.data)
        }
        else {
          dispatch(SetCloud('Global'))
        }
      })
    }
    else if (!storedTenantName && !storedTenantId && tenant !== 0 && stora === false) {
      getInfoSelectsGlobal(tenant).then(response => {
        if (response.data.length !== 0) {
          setInfo(response.data)
        }
        else {
          dispatch(SetCloud('Global'))
        }
      })
    }
    else if (storedTenantName && storedTenantId && tenant === 0 && stora === true) {
      getInfoSelects().then(response => {
        if (response.data.length !== 0) {
          setInfo(response.data)
        }
        else {
          dispatch(SetCloud('Global'))
        }
      })
    }
    else if (storedTenantName && storedTenantId && tenant !== 0 && stora === true) {
      getInfoSelectsGlobal(Number(storedTenantId)).then(response => {
        if (response.data.length !== 0) {
          setInfo(response.data)
        }
        else {
          dispatch(SetCloud('Global'))
        }

      })
    }
  }, [stora, setInfo, tenant])

  useEffect(() => {
    if (tenant === 0) {
      getListPermisos().then(response => {
        dispatch(SetListPerm(response.data));
      });
    } else if (tenant !== 0) {
      getListPermisostenant(tenant).then(response => {
        dispatch(SetListPerm(response.data));
        setPermissions(response.data);
      });
    }
  }, [tenant]);

  useEffect(() => {
    setlistSuscripciones([])
    for (const sus of Info) {
      if (sus) {
        setlistSuscripciones((oldArray: any) => [...oldArray, { id: sus.id, name: sus.name }]);
      }
    }
    // eslint-disable-next-line
  }, [Info])

  // Ajuste para "All Subscriptions"
  useEffect(() => {
    if (listSuscripciones && listSuscripciones.length > 0 && storedSuscription === null) {
      // Si hay más de una suscripción, seleccionamos "All Subscriptions"
      if (listSuscripciones.length > 1) {
        dispatch(SetId(-1))
        dispatch(SetNamesus('All Subscriptions'))
      } else {
        // Solo una suscripción
        dispatch(SetId(listSuscripciones[0].id))
        dispatch(SetNamesus(listSuscripciones[0].name))
      }
      dispatch(setFlagValue(false))
    }
    else if (storedSuscription !== null && stora === true) {
      dispatch(SetId(Number(storedSuscription)))
      dispatch(SetNamesus(String(storedSuscriptionName)))
      dispatch(setFlagValue(false))
    }

  }, [listSuscripciones, dispatch, stora])

  useEffect(() => {
    setlistcloud([])
    const selectedInfo = Info.find(info => info.id === Id);
    if (selectedInfo) {
      for (const cloud of selectedInfo.cloud) {
        setlistcloud((oldArray: any) => [...oldArray, { name: cloud.name }]);
      }
    }
  }, [setInfo, Info, stora, Id])

  useEffect(() => {
    if (listCloud !== undefined && listCloud.length > 0 && storedCloud === null) {
      dispatch(SetCloud(listCloud[0].name));
    }
    else if (storedCloud !== null && stora === true) {
      dispatch(SetCloud(String(storedCloud)))
    }
  }, [listCloud])

  useEffect(() => {
    setlistRegions([]);
    const selectedInfo = Info.find(info => info.id === Id);
    if (selectedInfo) {
      for (const cloud of selectedInfo.cloud) {
        if (cloud.name === Type) {
          for (const region of cloud.regions) {
            setlistRegions(oldArray => [...oldArray, region]);
          }
        }
      }
    }
  }, [Id, Info, Type]);

  // Efecto para la lógica de región
  useEffect(() => {
    if (listRegions.length > 1) {
      // Múltiples regiones: 'All Regions'
      dispatch(SetRegion(''));
      localStorage.removeItem('region');
    } else if (listRegions.length === 1) {
      // Una sola región
      dispatch(SetRegion(listRegions[0]));
      localStorage.setItem('region', listRegions[0]);
    } else {
      // Sin regiones
      dispatch(SetRegion(''));
      localStorage.removeItem('region');
    }
  }, [listRegions, dispatch]);

  const settenat = (id: string, Name: string) => {
    dispatch(SetTenant(Number(id)))
    dispatch(SetNameTenant(Name))

    localStorage.setItem('tenantId', id);
    localStorage.setItem('tenantName', Name);

    // Limpiamos selección previa
    localStorage.removeItem('suscription');
    localStorage.removeItem('suscriptionName');
    localStorage.removeItem('cloud');
    localStorage.removeItem('region');
  }

  const setSubscriptionMenu = (id: any, name: any) => {
    dispatch(SetId(id));
    dispatch(SetNamesus(name));

    localStorage.setItem('suscription', id);
    localStorage.setItem('suscriptionName', name);
    localStorage.removeItem('cloud');
    localStorage.removeItem('region');
  };

  const setcloudmenu = (id: string) => {
    dispatch(SetCloud(id))
    localStorage.setItem('cloud', id);
    localStorage.removeItem('region');
  }

  const setregionmenu = (region: string) => {
    if (region !== nameRegion) {
      dispatch(SetRegion(region));
      localStorage.setItem('region', region);
    }
  };

  const { pathname } = useLocation();

  useEffect(() => {
    if (Id === -1) {
      dispatch(SetCloud('CloudGlobal'))
      dispatch(SetRegion('ssws'))
    }
  }, [Id])

  useEffect(() => {
    if (Type === 'CloudGlobal') {
      dispatch(SetRegion(''))
    }
  }, [Type])

  return (
    <>
      {(currentUser?.ListPermiso?.includes('Tenant.list') || currentUser?.Multitenant) && (pathname.includes("/dashboard") || pathname.includes("/accounts/billing") || pathname.includes("/accounts/SSO") || pathname.includes("/accounts/Tenants") || pathname.includes("/CTX/datatransfer") || pathname.includes("/problemreport")
        || pathname.includes("/changerequest") || pathname.includes("/featurerequest") || pathname.includes("/CTX/troubleshooting") || pathname.includes("/accounts/users") || pathname.includes("/accounts/roles") || pathname.includes("/support/SeeRequest") || pathname.includes("CTX/addBPGSegment") || pathname.includes("CTX/addIPSecSegment")
        || pathname.includes("/accounts/subscriptions") || pathname.includes("/CTX-R/Management/Instances") || pathname.includes("/cloudConnectivity") || pathname.includes("/CTX-R/Management/neighbors") || pathname.includes("/CTX-R/visibility") || pathname.includes("/monitoring") || pathname.includes("/Entitlement") || pathname.includes("/FortinetDevices")
        || pathname.includes("/EdgeConnector") || pathname.includes("/CreateLicense") || pathname.includes("/CTX-R/status") || pathname.includes("/accounts/activitylogs")
        || pathname.includes("/CTX-R/Management/reporting"))
        &&
        <>
          <MenuCTXWithSub title={'' + (tenant !== 0 && NameTenant || tenant === 0 && 'Select tenant')} menuPlacement='bottom-start' menuTrigger='click'>
            <div className="menu-scroll">
              <div className='text-pink text-center'> -- TENANT -- </div>
              {Tenants.map((reg: any) => (
                <MenuItemTenantCTX
                  key={reg.id}
                  title={reg.Name}
                  Func={settenat}
                  Name={reg.Name}
                  id={reg.id}
                  hasBullet={true}
                />
              ))}
            </div>
          </MenuCTXWithSub>
        </>
      }

      {(pathname.includes("/dashboard") || pathname.includes("/accounts/billing") || pathname.includes("/CTX/datatransfer") || pathname.includes("/problemreport")
        || pathname.includes("/changerequest") || pathname.includes("/featurerequest") || pathname.includes("/CTX/troubleshooting") || pathname.includes("CTX/addBPGSegment") || pathname.includes("CTX/addIPSecSegment")
        || pathname.includes("/CTX-R/Management/Instances") || pathname.includes("/cloudConnectivity") || pathname.includes("/CTX-R/Management/neighbors") || pathname.includes("/CTX-R/visibility") || pathname.includes("/monitoring")
        || pathname.includes("/Entitlement") || pathname.includes("/FortinetDevices") || pathname.includes("/EdgeConnector") || pathname.includes("/CTX-R/status") || pathname.includes("/accounts/activitylogs")
        || pathname.includes("/CTX-R/Management/reporting") || pathname.includes("/CTX-R/Management/CreateLicense")) &&
        <>
          <MenuCTXWithSub title={nameSus} menuPlacement='bottom-start' menuTrigger='click'>
            <div className="menu-scroll">
              <div className='text-pink text-center'> -- SUBSCRIPTION -- </div>
              {
                listSuscripciones?.length > 1 &&
                <MenuItemCTX title={'All Subscriptions'} Func={setSubscriptionMenu} hasBullet={true} id={-1} />
              }
              {
                listSuscripciones?.map((sus: any) =>
                  <MenuItemCTX key={sus.id} title={sus.name} Func={setSubscriptionMenu} hasBullet={true} id={sus.id} />
                )
              }

            </div>

          </MenuCTXWithSub>
        </>
      }
      {(pathname.includes("/dashboard") || pathname.includes("/accounts/billing") || pathname.includes("/CTX/datatransfer") || pathname.includes("/problemreport")
        || pathname.includes("/changerequest") || pathname.includes("/featurerequest") || pathname.includes("/CTX/troubleshooting") || pathname.includes("CTX/addBPGSegment") || pathname.includes("CTX/addIPSecSegment")
        || pathname.includes("/CTX-R/Management/Instances") || pathname.includes("/cloudConnectivity") || pathname.includes("/CTX-R/Management/neighbors") || pathname.includes("/CTX-R/visibility") || pathname.includes("/monitoring")
        || pathname.includes("/Entitlement") || pathname.includes("/FortinetDevices") || pathname.includes("/EdgeConnector") || pathname.includes("/CTX-R/status") || pathname.includes("/accounts/activitylogs")
        || pathname.includes("/CTX-R/Management/reporting")) &&
        <>
          <MenuCTXWithSub title={Id === -1 ? 'All Clouds' : Type === 'AWS' ? 'Amazon Web Services' : Type === 'OCI' ? 'Oracle Cloud' : Type === 'AZR' ? 'Azure' : Type === 'CloudGlobal' ? 'All Clouds' : Type === 'GCP' ? 'Google Cloud' : ''} menuPlacement='bottom-start' menuTrigger='click'>
            <div className="menu-scroll">
              <div className='text-pink text-center'> -- CLOUD -- </div>
              <br />
              {
                listCloud?.length > 1 &&
                <MenuItemCTXaws title='All Clouds' icon='bi bi-globe' Func={setcloudmenu} id={'CloudGlobal'} />
              }
              {listCloud && listCloud.map((cloud: any) =>
                cloud.name === 'AWS' ? <MenuItemCTXaws key={cloud.name} title='Amazon Web Services' img='/media/iconos/AWS2.svg' Func={setcloudmenu} id={'AWS'} /> :
                  cloud.name === 'OCI' ? <MenuItemCTXaws key={cloud.name} title='Oracle Cloud' img='/media/iconos/Oracle2.svg' Func={setcloudmenu} id={'OCI'} /> :
                    cloud.name === 'AZR' ? <MenuItemCTXaws key={cloud.name} title='Azure' img='/media/iconos/Azure2.svg' Func={setcloudmenu} id={'AZR'} /> :
                      cloud.name === 'GCP' ? <MenuItemCTXaws key={cloud.name} title='Google Cloud' img='/media/iconos/GCP2.svg' Func={setcloudmenu} id={'GCP'} /> : 'All Clouds'
              )}
            </div>
          </MenuCTXWithSub>
        </>
      }
      {(pathname.includes("/dashboard") || pathname.includes("/accounts/billing") || pathname.includes("/CTX/datatransfer") || pathname.includes("/problemreport")
        || pathname.includes("/changerequest") || pathname.includes("/featurerequest") || pathname.includes("/CTX/troubleshooting") || pathname.includes("CTX/addBPGSegment") || pathname.includes("CTX/addIPSecSegment")
        || pathname.includes("/CTX-R/Management/Instances") || pathname.includes("/cloudConnectivity") || pathname.includes("/CTX-R/Management/neighbors") || pathname.includes("/CTX-R/visibility") || pathname.includes("/monitoring")
        || pathname.includes("/Entitlement") || pathname.includes("/FortinetDevices") || pathname.includes("/EdgeConnector") || pathname.includes("/CTX-R/status") || pathname.includes("/accounts/activitylogs")
        || pathname.includes("/CTX-R/Management/reporting")) &&

        <>
          <MenuCTXWithSub
            title={'' + (Id === -1 ? 'All Regions' : Type === 'CloudGlobal' ? 'All Regions' : nameRegion === '' ? 'All Regions' : nameRegion)}
            menuPlacement='bottom-start'
            menuTrigger='click'
          >
            <div className="menu-scroll">
              <div className='text-pink text-center'> -- REGION -- </div>

              {listRegions?.length > 1 && (
                <MenuItemCTX
                  title={'All Regions'}
                  Func={() => setregionmenu('')}
                  hasBullet={true}
                  id={''}
                />
              )}

              {listRegions.map((reg: any) => (
                <MenuItemCTX
                  key={reg}
                  title={reg}
                  Func={() => setregionmenu(reg)}
                  hasBullet={true}
                  id={reg}
                />
              ))}
            </div>
          </MenuCTXWithSub>
        </>
      }

    </>
  )
}
